import { Field, Checkbox, TextOutput } from 'Components/Core';
import { ListFieldSection } from 'Components/Layout';

let LayerBoundariesOptions: React.FC = () => {
  return (
    <>
      <Field input={<Checkbox />} name="JoinLayersOnChart" />
      <ListFieldSection>
        <Field input={<TextOutput />} name="StartDepth" />
        <Field input={<TextOutput />} name="FinalDepth" />
      </ListFieldSection>
    </>
  );
};

export { LayerBoundariesOptions };
